import React, { ReactElement } from 'react'
import Button from '../../button'
import Icon from '../../icon'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

type FilterPanelProps = {
  elmId?: string
  showCloseButton?: boolean
  onOpen: (isOpen: boolean) => void
  onReset: () => void
  children: ReactElement<ChildProps> | ReactElement<ChildProps>[]
}

type ChildProps = {
  elmId: string
}

const FilterPanel: React.FunctionComponent<FilterPanelProps> = ({
  elmId = 'filter_panel',
  showCloseButton = false,
  onOpen,
  onReset,
  children, // filter group layout generally
}) => {
  // pass elmId thru to children
  const content = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { elmId: `${elmId}_content` })
    }
    return child
  })

  return (
    <div className={cx('panel')}>
      {showCloseButton && (
        <Icon
          data-elm-id={`${elmId}_close_button`}
          className={cx('close-button')}
          name='times'
          iconStyle='regular'
          fitted
          size='large'
          onClick={() => onOpen(false)}
        />
      )}
      <div className={cx('content')}>{content}</div>

      <div className={cx('footer')}>
        <Button
          data-elm-id={`${elmId}_reset_button`}
          role='default'
          className={cx('reset-button')}
          onClick={onReset}
        >
          Reset
        </Button>
        <Button
          data-elm-id={`${elmId}_done_button`}
          role='primary'
          className={cx('done-button')}
          onClick={() => onOpen(false)}
        >
          Done
        </Button>
      </div>
    </div>
  )
}

export default FilterPanel
